import TraffiicFunnelIllustration from './assets/traffic-funnel-illustration.svg';
import ShopperEngagementChartIllustration from './assets/shopper-engagement-chart-illustration.svg';
import TopLocationsTableIllustration from './assets/top-locations-table-illustration.svg';
import TagsIllustration from './assets/tags-illustration.svg';
import NonVisitorInsight from './VisitorInsightCarousel/NonVisitorInsightCard';
import Hidden from 'raydiant-elements/layout/Hidden';

const NonVisitorInsightLayout = () => {
  const renderDesktopLayout = () => {
    return (
      <div className="p-6">
        <NonVisitorInsight />
        <div className="p-6">
          <div className="flex rounded-3xl justify-center gap-6">
            <div>
              <img src={TraffiicFunnelIllustration} alt="traffic funnel" />
            </div>
            <div>
              <img
                src={ShopperEngagementChartIllustration}
                alt="shopper engagement"
              />
            </div>
          </div>
          <div className="flex rounded-3xl justify-center gap-6 mt-3">
            <div>
              <img
                src={TopLocationsTableIllustration}
                alt="top locations chart"
              />
            </div>
            <div>
              <img src={TagsIllustration} alt="tags" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMobileLayout = () => {
    return (
      <div className="p-1">
        <NonVisitorInsight />
        <div>
          <div className="flex rounded-3xl flex-col">
            <div className="flex justify-center p-4 mt-3">
              <img src={TraffiicFunnelIllustration} alt="traffic funnel" />
            </div>
            <div>
              <img
                src={ShopperEngagementChartIllustration}
                alt="shopper engagement"
              />
            </div>
          </div>
          <div className="flex rounded-3xl flex-col">
            <div>
              <img
                src={TopLocationsTableIllustration}
                alt="top locations chart"
              />
            </div>
            <div className="flex justify-center p-4">
              <img src={TagsIllustration} alt="tags" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="card">
      <Hidden xsDown>{renderDesktopLayout()}</Hidden>
      <Hidden smUp>{renderMobileLayout()}</Hidden>
    </div>
  );
};

export default NonVisitorInsightLayout;
